export default "__VITE_ASSET__BHNlqKTW__"